<template>
  <div id="FiltrosDeBusqueda_div">
    <h2>Búsqueda</h2>
    <hr />
    <div class="form-group" v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == enumeraciones.catalogos.FechaDeInicio" id="FechaDeInicio_div">
      <label for="fechaDeInicio">Fecha inicial</label>
      <input type="date" id="fechaDeInicio" v-model="fechaInicial" @change="A_Comun_FechaInicial(fechaInicial)" class="form-control" />
    </div>
    <div class="form-group" v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == enumeraciones.catalogos.FechaFinal" id="FechaFinal_div">
      <label for="fechaFinal">Fecha final</label>
      <input type="date" id="fechaFinal" v-model="fechaFinal" @change="A_Comun_FechaFinal(fechaFinal)" class="form-control" />
    </div>
    <div class="form-group" v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == enumeraciones.catalogos.Fecha" id="FechaAudiencia_div">
      <label if="catalogo.titulo != undefined && catalogo.titulo != null" for="fecha">{{catalogo.titulo}}</label>
      <input type="date" id="fecha" v-model="fecha" @change="A_Comun_Fecha(fecha)" class="form-control" />
    </div>
    

    <div v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == enumeraciones.catalogos.PartidosJudiciales" id="PartidosJudiciales_div">
      <C009PartidosJudiciales v-on:valorParaElPadre="cambioDePartidoJudicial" :prefijo="catalogo.etiquetaDeHtml" :tipo="catalogo.tipoDeSelect" :idDelInput="'filtroDeBusqueda_PartidoJudicial'" :parametros="parametros_PartidoJudicial.parametros" :valorDefinido="parametros_PartidoJudicial.partidoJudicialId" :key="parametros_PartidoJudicial.key"></C009PartidosJudiciales>
    </div>
    <div v-if="parametros_PartidoJudicial.partidoJudicialId!=-1">
      <div v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == enumeraciones.catalogos.Materias" id="Materias_div">
        <C002Materias v-on:valorParaElPadre="cambioDeMateria" :prefijo="catalogo.etiquetaDeHtml" :tipo="catalogo.tipoDeSelect" :idDelInput="'filtroDeBusqueda_Materia'" :parametros="parametros_Materia" :valorDefinido="parametros_Materia.materiaId" :key="parametros_Materia.key"></C002Materias>
      </div>
      <div v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == enumeraciones.catalogos.Juzgados" id="Juzgados_div">
        <C001Area v-on:valorParaElPadre="cambioDeArea" :prefijo="catalogo.etiquetaDeHtml" :tipo="catalogo.tipoDeSelect" :idDelInput="'filtroDeBusqueda_Area'" :parametros="parametros_Area.parametros" :valorDefinido="parametros_Area.areaId" :key="parametros_Area.key"></C001Area>
      </div>
    </div>
    <div v-if="parametros_Area.areaId!=-1">
      <div v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == enumeraciones.catalogos.TiposDeDocumentos" id="TiposDeDocumentos_div">
        <C004TiposDocumento v-on:valorParaElPadre="cambioDeTipoDeDocumento" :prefijo="catalogo.etiquetaDeHtml" :tipo="catalogo.tipoDeSelect" :idDelInput="'filtroDeBusqueda_TipoDocumento'" :parametros="parametros_TipoDocumento.parametros" :valorDefinido="parametros_TipoDocumento.tipoDocumentoId" :key="parametros_TipoDocumento.key"></C004TiposDocumento>
      </div>
      <div v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == enumeraciones.catalogos.Salas" id="Salas_div">
        <C020Salas v-on:valorParaElPadre="cambioDeSala" :prefijo="catalogo.etiquetaDeHtml" :tipo="catalogo.tipoDeSelect" :idDelInput="'filtroDeBusqueda_Sala'" :parametros="parametros_Sala.parametros" :valorDefinido="parametros_Sala.salaId" :key="parametros_Sala.key"></C020Salas>
      </div>
      <div v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == enumeraciones.catalogos.TiposEstatusDeLaAudiencia" id="EstatusDeLaAudiencia_div">
        <C001TiposEstatusDeLaAudiencia v-on:valorParaElPadre="cambioDeTipoEstatus"  :prefijo="catalogo.etiquetaDeHtml" :tipo="catalogo.tipoDeSelect" :idDelInput="'filtroDeBusqueda_TipoEstatusDeLaAudiencia'" :parametros="parametros_TipoEstatusDeLaAudiencia.parametros" :valorDefinido="parametros_TipoEstatusDeLaAudiencia.tipoEstatusDeLaAudienciaId" :key="parametros_TipoEstatusDeLaAudiencia.key"></C001TiposEstatusDeLaAudiencia>
      </div>
      <div class="form-group" v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == enumeraciones.catalogos.Consecutivo" id="Consecutivo_div">
        <input class="form-control" type="text" placeholder="####/####" v-model="consecutivo" :idDelInput="'filtroDeBusqueda_Consecutivo'" :parametros="parametros_Consecutivo.parametros" @change="cambioDeConsecutivo($event)" v-mask="'####/####'" />
      </div>
      <div v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == enumeraciones.catalogos.OperadoresDeSala" id="OperadoresDeSala_div">
        <C001OperadoresDeSala v-on:valorParaElPadre="cambioDeOperador" :prefijo="catalogo.etiquetaDeHtml" :tipo="catalogo.tipoDeSelect" :idDelInput="'filtroDeBusqueda_OperadorDeSala'" :parametros="parametros_OperadorDeSala.parametros" :valorDefinido="parametros_OperadorDeSala.operadorDeSalaId" :key="parametros_OperadorDeSala.key"></C001OperadoresDeSala>
      </div>
    </div>
    <div id="RealizarFiltrosBusqueda_div" class="text-right">
      <button class="btn btn-primary overwrapDeBotones" id="realizarFiltrosBusqueda_btn" @click='ejecutaLaFuncion()'>Realizar búsqueda</button>
    </div>
  </div>
</template>

<script>
  //Importaciones estandarizadas
  import Vue from 'vue'
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import VueMask from 'v-mask'
  import { mapActions } from 'vuex'

  Vue.use(VueMask);

  export default {
    data() {
      return {
        enumeraciones,
        fechaInicial: moment().format('YYYY-MM-DD'),
        fechaFinal: moment().add(7, 'days').format('YYYY-MM-DD'),
        fecha: null,
        consecutivo: "",
        parametros_TipoEstatusDeLaAudiencia: {
          key: "",
          tipoEstatusDeLaAudiencia: 0,
          parametros: {}
        },
        parametros_PartidoJudicial: {
          key: "",
          partidoJudicialId: -1,
          parametros: {}
        },
        parametros_Area: {
          key: "",
          areaId: -1,
          parametros: {}
        },
        parametros_Materia: {
          key: "",
          materiaId: 9,
          parametros: {}
        },
        parametros_TipoDocumento: {
          key: "",
          tipoDocumentoId: -1,
          parametros: {}
        },
        parametros_Sala: {
          key: "",
          salaId: -1,
          parametros: {}
        },
        parametros_OperadorDeSala: {
          key: "",
          operadorDeSalaId: -1,
          parametros: {}
        },
        parametros_Consecutivo: {
          key: "",
          parametros: {}
        }
      }
    },
    components: {
      C001TiposEstatusDeLaAudiencia: catalogos.Forseti.C001TiposEstatusDeLaAudiencia,
      C009PartidosJudiciales: catalogos.PJ.C009PartidosJudiciales,
      C001Area: catalogos.PJ.C001Area,
      C002Materias: catalogos.PJ.C002Materias,
      C004TiposDocumento: catalogos.PJ.C004TipoDocumento,
      C020Salas: catalogos.PJ.C020Salas,
      C001OperadoresDeSala: catalogos.Cuentas.C001OperadoresDeSala
    },
    props: {
      catalogos: Array,
      ejecutaLaFuncion: Function,
      filtrosEstablecidos: {
        default: () => ({
          TiposEstatus: null,
        })
      },
      parametrosEstablecidos: {
        default: () => ({
          PartidoJudicialId: null,
          MateriaId: null,
          AreaId: null,
          TipoDocumentoId: null,
          TipoEstatusId: null,
          Consecutivo: null
        })
      }
    },
    mounted() {
      if (this.parametrosEstablecidos.Key != null && this.parametrosEstablecidos.Key != undefined && this.parametrosEstablecidos.Key != "") {
        this.parametros_PartidoJudicial.partidoJudicialId = this.parametrosEstablecidos.parametros.PartidoJudicialId != null ? this.parametrosEstablecidos.parametros.PartidoJudicialId : -1;
        this.parametros_PartidoJudicial.key = this.parametrosEstablecidos.parametros.PartidoJudicialId != null ? "PartidoJudicial_" + this.parametrosEstablecidos.parametros.PartidoJudicialId : "";

        this.parametros_Area.areaId = this.parametrosEstablecidos.parametros.AreaId != null ? this.parametrosEstablecidos.parametros.AreaId : -1;
        this.parametros_Area.key = this.parametrosEstablecidos.parametros.AreaId != null ? "Area_" + this.parametrosEstablecidos.parametros.AreaId : "";

        this.parametros_Materia.materiaId = this.parametrosEstablecidos.parametros.MateriaId != null ? this.parametrosEstablecidos.parametros.MateriaId : -1;
        this.parametros_Materia.key = this.parametrosEstablecidos.parametros.MateriaId != null ? "Materia_" + this.parametrosEstablecidos.parametros.MateriaId : "";

        this.parametros_TipoDocumento.tipoDocumentoId = this.parametrosEstablecidos.parametros.TipoDeDocumentoId != null ? this.parametrosEstablecidos.parametros.TipoDeDocumentoId : -1;
        this.parametros_TipoDocumento.key = this.parametrosEstablecidos.parametros.TipoDeDocumentoId != null ? "TipoDocumento_" + this.parametrosEstablecidos.parametros.TipoDeDocumentoId : "";

        this.consecutivo = this.parametrosEstablecidos.parametros.Consecutivo != null ? this.parametrosEstablecidos.parametros.Consecutivo : "";
      }
      if (this.filtrosEstablecidos.TiposEstatus != undefined && this.filtrosEstablecidos.TiposEstatus != null) {        
        this.parametros_TipoEstatusDeLaAudiencia.parametros.filtros = this.filtrosEstablecidos.TiposEstatus;
        this.parametros_TipoEstatusDeLaAudiencia.key = -1;
      }
    },
    created() {
      this.$store.dispatch('A_Comun_Consecutivo', this.consecutivo);
      this.$store.dispatch('A_Comun_FechaInicial', this.fechaInicial);
      this.$store.dispatch('A_Comun_FechaFinal', this.fechaFinal);
      this.$store.dispatch('A_Comun_Fecha', this.fecha);
    },
    methods: {
      cambioDeConsecutivo(datos) {
        //let idDelInput = "filtroDeBusqueda_Consecutivo";
        //const params = {
        //  llave: idDelInput,
        //  valor: datos.target.value
        //}

        this.$store.dispatch("A_Comun_Consecutivo", datos.target.value);
      },
      cambioDeTipoEstatus(datos) {
        this.parametros_TipoEstatusDeLaAudiencia.tipoEstatusDeLaAudiencia = parseInt(datos.target.value);       
      },
      cambioDePartidoJudicial(datos) {
        this.parametros_PartidoJudicial.partidoJudicialId = parseInt(datos.target.value);
        var changeMateria = {target: {value : ""}};
        changeMateria.target.value = "9"; // Materia Oral Penal
        this.cambioDeMateria(changeMateria);

        //Actualizo area
        this.parametros_Area.parametros.PartidoJudicialId = parseInt(datos.target.value);
        if (this.parametros_Area.areaId <= 0 || this.parametros_PartidoJudicial.partidoJudicialId <= 0)
          this.parametros_Area.key = "PartidoJudicial_" + datos.target.value;

        // //Actualizo sala
        // this.parametros_Sala.parametros.PartidoJudicialId = parseInt(datos.target.value);
        // if (this.parametros_Sala.salaId <= 0 || this.parametros_PartidoJudicial.partidoJudicialId <= 0)
        //   this.parametros_Sala.key = "Area_" + datos.target.value;
      },
      cambioDeArea(datos) {
        this.parametros_Area.areaId = parseInt(datos.target.value);

        //Actualizo partido
        this.parametros_PartidoJudicial.parametros.AreaId = parseInt(datos.target.value);
        if (this.parametros_PartidoJudicial.partidoJudicialId <= 0 || this.parametros_Area.areaId <= 0)
          this.parametros_PartidoJudicial.key = "Area_" + datos.target.value;

        //Actualizo materia
        this.parametros_Materia.parametros.AreaId = parseInt(datos.target.value);
        if (this.parametros_Materia.materiaId <= 0 || this.parametros_Area.areaId <= 0)
          this.parametros_Materia.key = "Area_" + datos.target.value;

        //Actualizo sala
        this.parametros_Sala.parametros.AreaId = parseInt(datos.target.value);
        if (this.parametros_Sala.salaId <= 0 || this.parametros_Area.areaId <= 0)
          this.parametros_Sala.key = "Area_" + datos.target.value;
      },
      cambioDeMateria(datos) {
        this.parametros_Materia.materiaId = parseInt(datos.target.value);

        //Actualizo area
        this.parametros_Area.parametros.MateriaId = parseInt(datos.target.value);
        if (this.parametros_Area.areaId <= 0 || this.parametros_Materia.materiaId <= 0)
          this.parametros_Area.key = "Materia_" + datos.target.value;

        //Actualizo tipo de documento
        this.parametros_TipoDocumento.parametros.MateriaId = parseInt(datos.target.value);
        if (this.parametros_TipoDocumento.tipoDocumentoId <= 0 || this.parametros_Materia.materiaId <= 0)
          this.parametros_TipoDocumento.key = "Materia_" + datos.target.value;
      },
      cambioDeTipoDeDocumento(datos) {
        this.parametros_TipoDocumento.tipoDocumentoId = parseInt(datos.target.value);

        //Actualizo materia
        this.parametros_Materia.parametros.TipoDocumentoId = parseInt(datos.target.value);
        if (this.parametros_Materia.materiaId <= 0 || this.parametros_TipoDocumento.tipoDocumentoId <= 0)
          this.parametros_Materia.key = "TipoDocumento_" + datos.target.value;
      },
      cambioDeSala(datos) {
        this.parametros_Sala.salaId = parseInt(datos.target.value);

        //Actualizo area
        this.parametros_Area.parametros.SalaId = parseInt(datos.target.value);
        if (this.parametros_Area.areaId <= 0 || this.parametros_Sala.salaId <= 0)
          this.parametros_Area.key = "Sala_" + datos.target.value;
      },
      cambioDeOperador(datos) {
        this.parametros_OperadorDeSala.operadorDeSalaId = parseInt(datos.target.value);
      },
      ...mapActions([
        'A_Comun_FechaInicial',
        'A_Comun_FechaFinal',
        'A_Comun_Fecha',
        'A_Comun_Consecutivo'
      ])
    }
  }

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Forseti/Comun/FiltrosDeBusqueda.vue